var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStockChart = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2.25C0 1.83579 0.335786 1.5 0.75 1.5C1.16421 1.5 1.5 1.83579 1.5 2.25V19.5C1.5 20.3284 2.17157 21 3 21H23.25C23.6642 21 24 21.3358 24 21.75C24 22.1642 23.6642 22.5 23.25 22.5H3C1.5 22.5 0 21 0 19.5V2.25ZM23.7803 4.71967C23.8522 4.79158 23.9065 4.87445 23.9431 4.96291C23.9792 5.05028 23.9982 5.14309 23.9999 5.23616L24 5.25147V11.25C24 11.6642 23.6642 12 23.25 12C22.8358 12 22.5 11.6642 22.5 11.25V7.06066L15.5303 14.0303C15.2374 14.3232 14.7626 14.3232 14.4697 14.0303L10.5 10.0607L4.28033 16.2803C3.98744 16.5732 3.51256 16.5732 3.21967 16.2803C2.92678 15.9874 2.92678 15.5126 3.21967 15.2197L9.96967 8.46967C10.2626 8.17678 10.7374 8.17678 11.0303 8.46967L15 12.4393L21.4393 6H17.25C16.8358 6 16.5 5.66421 16.5 5.25C16.5 4.83579 16.8358 4.5 17.25 4.5H23.25C23.3517 4.5 23.4487 4.52024 23.5371 4.55691C23.6255 4.59351 23.7084 4.64776 23.7803 4.71967Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStockChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stock-chart.92febe056b0f2a28490b7901b3a01a19.svg";